'use strict';
import $ from 'jquery';

export default class CF7 {
    static init() {
        $('.wpcf7').each((index, el) => {
            new CF7($(el));
        });
    }

    constructor($el) {
        this.el = $el;
        this.form = this.el.find('.wpcf7-form');
        this.el.on('wpcf7submit', this.onSubmit.bind(this));
    }

    onSubmit(e) {
        const self = this;
        // Validate custom fields
        if (this.el.find('input[type=time], select.wpcf7-timezone').length > 0) {
            this.el.find('input[type=time], select.wpcf7-timezone').each((i, el) => {
                const $input = $(el);
                if ($input.attr('required') && $input.val() === '') {
                    self.form.addClass('invalid');
                    $input.addClass('wpcf7-not-valid');
                } else {
                    $input.removeClass('wpcf7-not-valid');
                }
            });
        }
        if (false === this.form.hasClass('invalid')) {
            setTimeout(() => {
                const response = self.el.find('.wpcf7-response-output').clone();
                self.el.empty();
                self.el.append(response);
            }, 500);
        }
    }
}